import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5d18ccf7&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d18ccf7')) {
      api.createRecord('5d18ccf7', component.options)
    } else {
      api.reload('5d18ccf7', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5d18ccf7&", function () {
      api.rerender('5d18ccf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/comp/ImgFallback.vue"
export default component.exports